// «الدعم الفني» in the school dashboard: the same /user/support API the school app uses (AI assistant,
// «الدعم الفني السريع» tickets, my tickets). Every school account and supervisor can use it, also
// when a subscription has expired.

export const WHATSAPP = 'https://wa.me/966580200670';
export const WHATSAPP_LABEL = '966580200670';
export const SERVICES = ['الطلاب', 'المعلمين', 'الحصص', 'الرسائل', 'أخرى'];
export const MAX_FILES = 5;
export const MAX_VOICE_SECONDS = 180;
export const FILE_ACCEPT = '.jpg,.jpeg,.png,.webp,.heic,.pdf,.doc,.docx,.xls,.xlsx';

const OFFLINE = 'تعذّر الاتصال بالخادم. تحقق من الإنترنت وحاول مرة أخرى.';

function jwt(){
  try { return JSON.parse(localStorage.getItem('user')).jwt; } catch (e) { return ''; }
}

// → { ok: true, data } or { ok: false, message } (never rejects)
export function call(path, data){
  return new Promise(function(resolve){
    $.ajax({
      type: 'POST',
      url: window.api + '/user/support' + path,
      data: Object.assign({ jwt: jwt() }, data || {}),
      timeout: 40000,
    }).then(function(r){
      if (r && r.status == 100) resolve({ ok: true, data: r.response });
      // paid_only: «الدعم الفني السريع» refused for a school without a paid subscription
      else resolve({ ok: false, message: (r && typeof r.response == 'string' && r.response) || 'حدث خطأ، حاول مرة أخرى',
        paid_only: !!(r && r.paid_only), urgent_blocked: !!(r && r.urgent_blocked) });
    }).fail(function(){
      resolve({ ok: false, message: OFFLINE });
    });
  });
}

// One file or recorded blob → { ok, data: { url, kind, file_name } } through /user/support/upload.
export function upload(file, name, onProgress){
  return new Promise(function(resolve){
    var form = new FormData();
    form.append('file', file, name || file.name || 'file');
    form.append('jwt', jwt());
    $.ajax({
      type: 'POST',
      url: window.api + '/user/support/upload',
      data: form,
      cache: false,
      contentType: false,
      processData: false,
      timeout: 120000,
      xhr: function(){
        var x = $.ajaxSettings.xhr();
        if (x.upload && onProgress) {
          x.upload.addEventListener('progress', function(e){
            if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
          }, false);
        }
        return x;
      },
    }).then(function(r){
      if (r && r.status == 100) resolve({ ok: true, data: r.response });
      else resolve({ ok: false, message: (r && typeof r.response == 'string' && r.response) || 'تعذّر رفع الملف، حاول مرة أخرى' });
    }).fail(function(){
      resolve({ ok: false, message: 'تعذّر رفع الملف، حاول مرة أخرى' });
    });
  });
}

// kind of a picked file (the server decides too, this is only for the preview)
export function kindOf(name){
  var ext = ((name || '').split('.').pop() || '').toLowerCase();
  if (['jpg', 'jpeg', 'png', 'webp', 'heic'].includes(ext)) return 'image';
  if (['m4a', 'aac', 'mp4', 'mp3', 'mpeg', 'wav', 'ogg', 'opus', 'webm'].includes(ext)) return 'voice';
  return 'file';
}

export function seconds(n){
  n = Math.max(0, Math.round(Number(n) || 0));
  var m = Math.floor(n / 60), s = n % 60;
  return m + ':' + (s < 10 ? '0' : '') + s;
}

function parse(v){
  if (!v) return null;
  if (v instanceof Date) return v;
  var s = v.toString();
  // Riyadh "YYYY-MM-DD HH:mm" from older rows
  var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(s);
  if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] - 3, +m[5]));
  var d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

function riyadh(d){
  // the parts of a date as Riyadh reads it
  var p = {};
  new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Riyadh', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    .formatToParts(d).forEach(function(x){ p[x.type] = x.value; });
  return p;
}

export function timeOf(v){
  var d = parse(v);
  if (!d) return '';
  var p = riyadh(d), h = +p.hour;
  return (h % 12 || 12) + ':' + p.minute + ' ' + (h < 12 ? 'ص' : 'م');
}

export function dayOf(v){
  var d = parse(v);
  if (!d) return '';
  var p = riyadh(d), t = riyadh(new Date()), y = riyadh(new Date(Date.now() - 86400000));
  var key = p.year + '-' + p.month + '-' + p.day;
  if (key == t.year + '-' + t.month + '-' + t.day) return 'اليوم';
  if (key == y.year + '-' + y.month + '-' + y.day) return 'أمس';
  return key;
}

// «منذ 5 د» style for lists
export function ago(v){
  var d = parse(v);
  if (!d) return '';
  var mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return 'الآن';
  if (mins < 60) return 'منذ ' + mins + ' د';
  if (mins < 24 * 60) return 'منذ ' + Math.floor(mins / 60) + ' س';
  var day = dayOf(d);
  return day == 'أمس' ? 'أمس' : day;
}

// What the support page offers this school (/user/support/eligibility):
//   'allowed'        — paid, current subscription → «الدعم الفني السريع» (urgent tickets)
//   'blocked'        — stopped by the support team → «تذكرة دعم فني» (normal tickets) instead
//   'not_subscribed' — demo / none / expired → subscribe first (no ticket)
//   null             — unknown (older server / offline): the urgent form opens, the server decides
export const PAID_ONLY = 'الدعم الفني السريع متاح للمشتركين فقط، اشترك أولاً في أي خدمة من خدمات النظام.';
export const BLOCKED = 'تم إيقاف إنشاء التذاكر العاجلة لحسابكم، يمكنكم فتح تذكرة دعم عادية';
export function urgentAccess(){
  return call('/eligibility').then(function(r){
    var d = (r.ok && r.data) || {};
    var state = ['allowed', 'blocked', 'not_subscribed'].includes(d.state) ? d.state : (d.urgent === true ? 'allowed' : null);
    return { state: state, message: d.message || '' };
  });
}
